import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IRosterType } from "../shared/models/roster/roster-type";
import { ApiUrlProvider } from "./api-url.provider";

@Injectable({
  providedIn: "root"
})
export class RosterTypeService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterType[]>>{
    return this.http.get<IApiResult<IRosterType[]>>(`${this.apiUrlProvider.url}/RosterType`);
  }

  add(entity: IRosterType): Observable<IApiResult<IRosterType>>{
    return this.http.post<IApiResult<IRosterType>>(`${this.apiUrlProvider.url}/RosterType`, entity);
  }

  update(entity: IRosterType): Observable<IApiResult<IRosterType>>{
    return this.http.post<IApiResult<IRosterType>>(`${this.apiUrlProvider.url}/RosterType/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/RosterType/${entityId}/delete`, null);
  }
}
